import React from 'react'
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css"
import Loader from 'react-loader-spinner';
import './loader.css'

const Spinner = () => {
    return (
        <div className="loader-container" >
            <div className="loader" style={{ textAlign: "center" }}>
                <br/><br/><br/><br/><br/><br/>
                <Loader
                    type="ThreeDots"
                    color="#00BFFF"
                    height={100}
                    width={100}
                />
            </div>
        </div>
    )
}

export default Spinner
